import { show } from '@intercom/messenger-js-sdk';
import { Tooltip, TooltipContent, TooltipTrigger } from '@plato/ui/primitives/tooltip';
import { CircleHelpIcon } from 'lucide-react';
import * as React from 'react';
import { Button, type ButtonProps } from '../../../components/ui/button.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import { cn } from '../../../lib/utils.ts';

export type IntercomLauncherProps = {
    expanded?: boolean;
    className?: string;
    variant?: ButtonProps['variant'];
};

const IntercomLauncher = React.forwardRef<HTMLButtonElement, IntercomLauncherProps>(
    ({ expanded = true, className = '', variant = 'ghost' }, ref) => {
        const { t } = useLocale('common');

        if (expanded) {
            return (
                <Button
                    ref={ref}
                    className={cn('w-full justify-start text-neutral-950', className)}
                    variant={variant}
                    onClick={() => {
                        show();
                    }}
                    leftIcon={CircleHelpIcon}
                >
                    <span className="font-normal">{t('support__button')}</span>
                </Button>
            );
        }

        return (
            <Tooltip>
                <TooltipTrigger
                    render={
                        <Button
                            ref={ref}
                            variant={variant}
                            size="icon-s"
                            onClick={() => {
                                show();
                            }}
                            icon={CircleHelpIcon}
                        />
                    }
                />
                <TooltipContent side="right">{t('support__button')}</TooltipContent>
            </Tooltip>
        );
    },
);
IntercomLauncher.displayName = 'IntercomLauncher';

export { IntercomLauncher };
